export default __webpack_public_path__ + "static/media/Hollywood.a6dbe7b4.jpg";